import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutTopFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLayoutTopFull"><Path d="M3 9V3H21V9L3 9Z" fill="currentColor"/><Path d="M3 11V21H21V11L3 11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutTopFull;
